import { gql } from "@apollo/client";

export const GET_ALL_CREW_MEMBERS_WITH_FULL_DETAIL = gql`
    query {
        allCrewMembers {
            id

            firstName
            lastName
            phone
            email

            street1
            street2
            city
            state
            zipcode

            isForeman
            isActive
            classification

            user {
                id
                username
                firstName
                lastName
                email
            }

            createdBy {
                id
            }
            lastUpdatedBy {
                id
            }
        }
    }
`

export const GET_CREW_MEMBER_BY_ID_WITH_FULL_DETAIL = gql`
    query crewMember($id: Int!) {
        crewMember(id: $id) {
            id

            firstName
            lastName
            phone
            email

            street1
            street2
            city
            state
            zipcode

            isForeman
            isActive
            classification

            user {
                id
                username
                firstName
                lastName
                email
            }

            createdBy {
                id
            }
            lastUpdatedBy {
                id
            }
        }
    }
`

export const GET_CREW_MEMBER_FOR_EDIT_FORM = gql`
    query crewMember($id: Int!) {
        crewMember(id: $id) {
            id

            firstName
            lastName
            phone
            email

            street1
            street2
            city
            state
            zipcode

            isForeman
            isActive
            classification

            user {
                id
                username
                firstName
                lastName
                email
            }

            emergencyContacts {
                id
                firstName
                lastName
                phone
                isPrimary
            }

            certifications {
                id
                name
                expirationDate
            }
        }
    }
`

export const GET_ALL_CREW_MEMBERS_FOR_SELECT_FIELD = gql`
    query {
        allCrewMembers {
            id
            firstName
            lastName
            classification
            isActive
        }
    }
`

// UPDATED QUERY: Use the new query name without arguments
export const GET_ALL_FOREMAN_USERS = gql`
    query {
        allForemanUsers {
            id
            username
            firstName
            lastName
            email
            phone
            isForeman
            isActive
        }
    }
`

// Crew Members by Position - Foreman & Regular
export const GET_CREW_MEMBERS_BY_POSITION = gql`
    query crewMembersByPosition($isForeman: Boolean!) {
        crewMembersByPosition(isForeman: $isForeman) {
            id
            firstName
            lastName
            classification
            phone
            email
        }
    }
`

// Crew Member - Name & is foreman
export const GET_CREW_MEMBER_BY_ID_WITH_NAME_AND_IS_FOREMAN = gql`
    query crewMember($id: Int!){ 
        crewMember(id: $id) {
            firstName
            lastName
            isForeman
        }
    }
`

// Crew Member - Certifications
export const GET_CREW_MEMBER_BY_ID_WITH_CERTIFICATIONS = gql`
    query crewMember($id: Int!) {
        crewMember(id: $id) {
            certifications {
                name
            }
        }
    }
`

// Crew Member - Profile
export const GET_CREW_MEMBER_BY_ID_PROFILE = gql`
    query crewMember($id: Int!) {
        crewMember(id: $id) {
            phone
            email
            classification
            street1
            street2
            city
            state
            zipcode
        }
    }
`

// Crew Member - Emergency Contacts
export const GET_CREW_MEMBER_BY_ID_WITH_EMERGENCY_CONTACTS = gql`
    query crewMember($id: Int!) {
        crewMember(id: $id) {
            emergencyContacts {
                firstName
                lastName
                phone
                isPrimary
            }
        }
    }
`

// Crew Member - Assignments
export const GET_CREW_MEMBER_BY_ID_WITH_ASSIGNMENTS = gql`
    query crewMember($id: Int!) {
        crewMember(id: $id) {
            isForeman
            assignments {
                id
                jobDay {
                    job {
                        name
                    }
                    date
                }
                startTime
                endTime
            }
        }
    }
`
